<!--
    校区管理-校区列表
    作用：展示校区列表详情
    功能：展示列表数据、数据筛选、各类校区权限控制、年服务设置、年服务记录
    组件：AppList、TypeSelect、AppSearch
    说明：新增了3.0相关功能
-->
<template>
  <div class="list">
    <AppList
      :list.sync="list"
      title=""
      api="/api/service/operate/school_list"
    >
      <el-row
        slot="search"
        type="flex"
        align="middle">
        <div
          style="float: left;line-height: 32px; color: #303133;"
        >校区分类: &nbsp;</div>

        <TypeSelect
          :root-catalog="'校区分类'"
          :root-title="'校区分类编辑'"
          :data.sync="typeSelectDataMe"
          :values="typeSelectValue"
          type="school_category"
          @onTypeSelect="onTypeSelect"
        />

        <AppSearch
          :order="{ type: 'id', name: 'desc'}"
          :search-arr="searchArr"
        />
      </el-row>

      <template slot-scope="props">
        <el-table :data="props.listData">
          <el-table-column
            v-for="column in columns"
            :key="column.prop"
            :prop="column.prop"
            :label="column.label"
            :width="column.width"
            :formatter="column.formatter"
          />
          <el-table-column
            label="课程上架权限"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.enable_course_package === 1">启用</span>
              <span v-else>禁用</span>
              <el-switch
                :value="scope.row.enable_course_package === 1"
                active-color="#13ce66"
                inactive-color="#e3e3e3"
                @change="changeCourseAuth(scope.row)"/>
            </template>
          </el-table-column>
          <el-table-column
            label="sdk上课权限"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.configs&&scope.row.configs.sdk_enable === 1">启用</span>
              <span v-else>禁用</span>
              <el-switch
                :value="scope.row.configs&&scope.row.configs.sdk_enable === 1"
                active-color="#13ce66"
                inactive-color="#e3e3e3"
                @change="changeSdkAuth(scope.row)"/>
            </template>
          </el-table-column>
          <el-table-column
            label="课件权限"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.clients_course_make_status === 1">启用</span>
              <span v-else>禁用</span>
              <el-switch
                :value="scope.row.clients_course_make_status === 1"
                active-color="#13ce66"
                inactive-color="#e3e3e3"
                @change="switchCourseMake(scope.row)"/>
            </template>
          </el-table-column>

          <el-table-column
            label="操作"
            width="320px"
            class="orgin-btn"
          >
            <template slot-scope="scope">
              <el-button
                size="small"
                @click="doubleYun(scope.row)"
              >擎想系统课件</el-button>

              <el-popover
                placement="left"
                trigger="hover"
                popper-class="vip-popover"
              >
                <div class="flex-column">
                  <el-button
                    size="small"
                    @click="setWechat(scope.row)"
                  >小程序</el-button>
                  <el-button
                    v-if="scope.row.school_is_master === 1 && !scope.row.as_agent"
                    size="small"
                    @click="setting(scope.row)"
                  >设置</el-button>
                  <el-button
                    size="small"
                    @click="getAuthClass(scope.row)"
                  >授权课包</el-button>
                  <el-button
                    size="small"
                    @click="moreMove(scope.row.id)"
                  >移动</el-button>

                  <!-- <el-button
                    size="small"
                    @click="setMembershipLevels(scope.row)"
                  >设置会员等级</el-button> -->
                  <el-button
                    size="small"
                    @click="openAnnualFee(scope.row)"
                  >年服务设置</el-button>
                  <el-button
                    size="small"
                    @click="practiceFeeConfiguration(scope.row)"
                  >练习收费配置</el-button>
                  <!-- <el-button
                    size="small"
                    @click="openMembershipRecords(scope.row)"
                  >查看会员记录</el-button> -->
                  <el-button
                    size="small"
                    @click="openChangeLog(scope.row)"
                  >查看变更记录</el-button>
                  <el-button
                    size="small"
                    @click="openAccountNum(scope.row)"
                  >配置账号数量</el-button>
                  <el-button
                    size="small"
                    @click="openAuthNum(scope.row)"
                  >课后条数授权</el-button>
                </div>

                <el-button
                  slot="reference"
                  style="margin-left: 10px;"
                  size="small">更多</el-button>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </AppList>
    <el-dialog
      :visible.sync="dialogVisible"
      title="设置"
      width="500px">
      <el-form
        ref="form"
        :model="form"
        label-width="120px">
        <el-form-item label="升级代理商">
          <el-radio-group v-model="form.factor">
            <el-radio :label="2">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitSetting">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="wechatDialogVisible"
      title="关联小程序"
      width="500px">
      <el-form
        ref="form"
        :model="form"
        label-width="120px">
        <el-form-item label="关联小程序：">
          {{ wechatForm.text }} {{ isRelevance ? '（已关联）' : '' }}
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer">
        <el-button @click="wechatDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitWechat">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 授权课包 -->
    <el-dialog
      v-if="authClass.show"
      :title="authClass.title"
      :visible.sync="authClass.show"
      center
      width="1471px"
    >
      <AppList
        :list.sync="authClass.list"
        :is-loading="authClass.loading"
        :exit-url="false"
        :api="authClass.api"
        :api-type="authClass.api"
        :page-call="pageCall"
        title=""
        class="search-fix1"
      >
        <el-row
          slot="search"
          type="flex"
          justify="space-between"
        >
          <AppSearch
            :order="{ type: 'id', name: 'desc'}"
            :search-arr="authClassAttr"
            :search-call="searchCall"
          />

          <el-button
            type="primary"
            @click="authClass.show = false">确 认</el-button>
        </el-row>

        <template slot-scope="props">
          <ul
            v-if="props.listData && props.listData.length"
            class="goods-ul">
            <li
              v-for="item in props.listData"
              :key="item.id"
              class="goods-li">
              <div class="goods-head pr">
                <img :src="item.image || item.cover || noCover">
                <div
                  v-if="item.video"
                  class="goods-video">
                  <div
                    class="video-btn"
                    @click.stop="showVideo(item.name, item.video)"/>
                </div>
                <el-checkbox
                  :class="[{aa: item.school_ids.includes(authClass.id)}, authClass.id]"
                  :value="item.school_ids.includes(authClass.id)"
                  class="select-check"
                  @change="val => GoodsCheck(val, item)"/>
              </div>

              <div class="goods-foot flex ac jb">
                <h3 class="goods-title elps">{{ item.name }}</h3>
                <el-popover
                  v-if="item.detail && item.introduction"
                  width="212"
                  offset="10"
                  placement="top-start"
                  popper-class="goods-tip-con"
                  trigger="hover"
                >
                  <figure>
                    <h4>主要介绍</h4>
                    <div
                      class="goods-tip-rec-detail"
                      v-html="item.detail.replace(/iframe/g, 'video').replace(/<video/g, '<video controls').replace(/(<img|<video)/, '$1 style=display:block; ')"/>
                  </figure>
                  <figure>
                    <h4 class="goods-tip-rec-class">课程包简介</h4>
                    <p>{{ item.introduction }}</p>
                  </figure>
                  <i
                    slot="reference"
                    class="goods-tip el-icon-warning-outline"/>
                </el-popover>
              </div>
            </li>
          </ul>
          <div
            v-else
            class="goods-empty flex dc ac jc">
            <i/>
            <p>暂无数据</p>
          </div>
        </template>
      </AppList>
    </el-dialog>

    <el-dialog
      :title="videoData.title"
      :visible.sync="videoData.show"
      class="dialog-sp1 dialog-video"
      width="692px"
      @opened="videoOpen"
      @close="videoClose"
    >
      <video
        ref="ref_video"
        :src="videoData.src"
        controls="controls"
        width="100%"/>
    </el-dialog>

    <!--移动-->
    <el-dialog
      :visible.sync="moves.show"
      title="移动"
      width="460px"
    >
      <EleForm
        ref="movesForm"
        :form="moves.form"
        :is-submit="moves.isSubmit"
        @onAttr="onMovesForm"
      />

      <span
        slot="footer"
        class="dialog-footer">
        <el-button @click="moves.show = false">取 消</el-button>
        <el-button
          type="primary"
          @click="moves.isSubmit = true">确 定</el-button>
      </span>
    </el-dialog>

    <!--设置会员等级-->
    <el-dialog
      v-if="dialogLevel.show"
      :visible.sync="dialogLevel.show"
      title="设置会员等级"
      width="460px"
    >
      <el-form
        v-loading.lock="dialogLevel.loading"
        ref="form_level"
        :model="form"
        label-width="120px"
      >
        <el-form-item label="校区名称:">
          <span>{{ dialogLevel.name }}</span>
        </el-form-item>

        <el-form-item label="校区等级:">
          <el-select
            v-model="dialogLevel.level"
            placeholder="请选择">
            <el-option
              v-for="item in dialogLevel.levelOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          v-if="dialogLevel.level > 0"
          label="有效期:">
          <el-date-picker
            v-model="dialogLevel.date"
            :clearable="false"
            :prefix-icon="null"
            :picker-options="pickerOptions"
            class="level-date-style"
            unlink-panels
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="changeLevel"
          />
        </el-form-item>
      </el-form>

      <span
        slot="footer"
        class="dialog-footer">
        <el-button
          type="primary"
          @click="dialogLevelSubmit">确 定</el-button>
      </span>
    </el-dialog>

    <!--校区练习收费规则配置-->
    <el-dialog
      v-if="dialogFee.show"
      :visible.sync="dialogFee.show"
      title="校区练习收费规则配置"
      width="460px"
    >
      <el-form
        v-loading.lock="dialogFee.loading"
        ref="form_fee"
        :model="form"
        label-width="120px"
      >
        <el-form-item label="校区名称:">
          <span>{{ dialogFee.name }}</span>
        </el-form-item>

        <div class="style-fee">
          每人每月收费
          <el-input
            v-model="dialogFee.coin"
            @change="dialogFeeInput"/>
          元或金币
        </div>
      </el-form>

      <span
        slot="footer"
        class="dialog-footer">
        <el-button
          type="primary"
          @click="dialogFeeSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 查看会员记录 -->
    <el-dialog
      v-if="dialogMember.show"
      :visible.sync="dialogMember.show"
      title="会员记录"
      width="1471px"
    >
      <div>校区名称：{{ dialogMember.title }}</div>
      <AppList
        :list.sync="dialogMember.list"
        :exit-url="false"
        :is-loading="dialogMember.loading"
        :api="dialogMember.api"
        title=""
      >
        <template slot-scope="props">
          <el-table :data="props.listData">
            <!-- <el-table-column
              prop="vip"
              label="会员等级"
              min-width="110"
            /> -->
            <el-table-column
              label="有效期"
              min-width="200"
            >
              <template slot-scope="{row}">
                <div v-if="row.vip">{{ row.vip_start_at }}~{{ row.vip_end_at }}</div>
                <div v-else>--</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="created_at"
              min-width="110"
              label="变更时间"
            />
            <el-table-column
              prop="admin_user.mobile"
              min-width="110"
              label="变更账号"
            />
            <el-table-column
              min-width="110"
              prop="admin_user.name"
              label="变更人员"
            />
          </el-table>
        </template>
      </AppList>
    </el-dialog>
    <!-- 年服务设置 -->
    <set-annual-fee
      v-if="showAnnualFee"
      :item="curRow"
      :visible.sync="showAnnualFee"
      :picker-options="feePickerOptions"
      @close-dialog="showAnnualFee = false"
      @refresh-data="reload" />
    <!-- 配置账号数量 -->
    <set-account-num
      v-if="showAccountNum"
      :item="curRow"
      :visible.sync="showAccountNum"
      @close-dialog="showAccountNum = false"
      @refresh-data="reload" />
    <!-- 配置授权数量 -->
    <set-authorize-num
      v-if="showAuthorizeNum"
      :item="curRow"
      :visible.sync="showAuthorizeNum"
      @close-dialog="showAuthorizeNum = false"
      @refresh-data="reload" />
    <!-- 变更记录 -->
    <see-change-log
      v-if="showChangeLog"
      :item="curRow"
      :visible.sync="showChangeLog"
      @close-dialog="showChangeLog = false" />
  </div>
</template>

<script>
import TypeSelect from '../../components/typeSelect2/categoryIndex';
import noCover from '@/assets/images/no-cover.png';
import SetAnnualFee from './dialog/setAnnualFee.vue';
import setAccountNum from './dialog/setAccountNum.vue';
import setAuthorizeNum from './dialog/setAuthorizeNum.vue';
import seeChangeLog from './dialog/seeChangeLog.vue';

export default {
  name: 'Campus',
  components: {
    TypeSelect,
    SetAnnualFee,
    setAccountNum,
    setAuthorizeNum,
    seeChangeLog,
  },
  inject: ['reload'],
  data() {
    return {
      show: true,
      list: {},
      isClick: false,
      showAnnualFee: false, // 年份服务设置
      showAccountNum: false, // 账号数量设置
      showAuthorizeNum: false, // 授权数量设置
      showChangeLog: false, // 变更记录
      feePickerOptions: {},
      curRow: {}, // 当前项
      columns: [
        {
          prop: 'review_used.name',
          label: '校区名称',
        },
        {
          label: '校区分类',
          width: '80px',
          formatter: (row) => {
            let val = '--';
            if (row.school_category_ids) {
              const typeId = row.school_category_ids[0];
              val = this.categoryType[typeId];
            }
            return val;
          },
        },
        {
          prop: 'school_code',
          width: '110px',
          label: '校区代码',
        },
        // {
        //   prop: 'vip',
        //   label: '会员等级',
        // },
        {
          prop: 'created_at',
          label: '入驻时间',
          width: '100px',
        }, {
          label: '服务有效期',
          width: '100px',
          formatter: (row) => {
            let val = '--';

            if (row.vip_start_at) {
              val = `${row.vip_start_at} ~  ${row.vip_end_at}`;
            }

            return val;
          },
        }, {
          label: '类型',
          formatter: row => (row.school_is_master === 1 ? '总校' : '分校'),
        }, {
          prop: 'user_count',
          label: '账号数',
        }, {
          prop: 'master_info.name',
          label: '所属主体',
        }, {
          label: '状态',
          formatter: (row) => {
            let val = '--';
            if (row.is_try_vip === 1) {
              val = '体验中';
            } else if (row.vip_type === 2) {
              val = row.vip_expired ? '已过期' : '进行中';
            }
            return val;
          },
        }, {
          prop: 'review_used.user_name',
          label: '校长',
        }, {
          prop: 'review_used.user_mobile',
          label: '校长电话',
        },
        // {
        //   prop: 'agent_info.agent.name',
        //   label: '关联代理商',
        // },
      ],
      dialogVisible: false,
      authClassVisible: false, // 显示授权课件
      authClassData: {}, // 授权课件数据
      wechatDialogVisible: false,
      user_id: '',
      form: {
        factor: 2,
      },
      wechatForm: {
        id: '',
        mark: 'xiaotianquan',
        text: '校天犬',
      },
      isRelevance: false,

      typeSelectDataMe: [
        {
          id: 0,
          name: '所有分类',
          delete: true,
        },
      ],

      moves: {
        show: false,
        data: [],
        options: [],
        isSubmit: false,
        form: [],
      },
      authClass: {
        title: '授权课包',
        loading: false,
        show: false,
        api: '',
        id: '',
        list: {
          items: [],
        },
        per_page: 10,
        page: 1,
        search: [],
      },
      videoData: {
        show: false,
        title: '',
      },
      noCover,

      typeSelectValue: [],

      dialogLevel: {
        show: false,
        loading: false,
        level: 0,
        date: [],
        dates: [],
        created_at: '',
        levelOption: [
          {
            value: 0,
            label: '0 (非会员)',
          },
          {
            value: 1,
            label: '1',
          },
          {
            value: 2,
            label: '2 (未开放)',
            disabled: true,
          },
          {
            value: 3,
            label: '3 (未开放)',
            disabled: true,
          },
        ],
      },

      dialogFee: {
        show: false,
        loading: false,
        coin: 0,
      },
      dialogMember: {
        title: '会员记录',
        loading: false,
        show: false,
        api: '',
        id: '',
        list: {
          item: [],
        },
        noItem: true,
        per_page: 10,
        page: 1,
      },
      pickerOptions: {},
    };
  },
  computed: {
    searchArr() {
      const column = [
        {
          prop: 'name',
          label: '校区名称',
        },
        {
          label: '校长名称',
          prop: 'user_name',
        },
        {
          label: '校长电话',
          prop: 'user_mobile',
          tel: true,
        },
        {
          label: '所属主体名称',
          prop: 'master_name',
        },
        {
          label: '所属主体电话',
          prop: 'master_mobile',
          tel: true,
        },
      ];
      return [
        {
          selectValue: [
            { value: 1, name: '体验中' },
            { value: 2, name: '进行中' },
            { value: 3, name: '已过期' },
          ],
          componentType: 'AppSearchStatus',
          searchType: 'search_vip_status',
          placeholder: '请选择校区状态',
        },
        // {
        //   selectValue: [
        //     { value: 0, name: '0' },
        //     { value: 1, name: '1' },
        //   ],
        //   componentType: 'AppSearchStatus',
        //   searchType: 'vip',
        //   placeholder: '会员等级',
        // },
        {
          selectValue: [
            { value: 1, name: '总校' },
            { value: 0, name: '分校' },
          ],
          componentType: 'AppSearchStatus',
          searchType: 'school_is_master',
          placeholder: '请选择类型',
        },
        { componentType: 'AppSearchColumn', searchType: column },
      ];
    },
    authClassAttr() {
      return [
        {
          selectValue: [
            { value: 1, name: '已选' },
            { value: 0, name: '未选' },
          ],
          componentType: 'AppSearchStatus',
          searchType: 'open_school_select',
          placeholder: '请选择类型',
        },
        {
          componentType: 'AppSearchColumn',
          searchType: '',
          searchType: [
            { prop: 'open_school_name', label: '校区名称' },
            { prop: 'open_school_mobile', label: '手机号', tel: true },
          ],
          label: '已开放校区',
        },
        {
          selectValue: this.stage_tag_list ? this.stage_tag_list.map(item => ({ value: item.id, name: item.name })) : [],
          componentType: 'AppSearchStatus',
          searchType: 'stage_tag_id',
          label: '学生年级',
        },
        {
          selectValue: this.subject_tag_list ? this.subject_tag_list.map(item => ({ value: item.id, name: item.name })) : [],
          componentType: 'AppSearchStatus',
          searchType: 'subject_tag_id',
          label: '学生科目',
        },
        {
          componentType: 'AppSearchColumn',
          searchType: 'name',
          placeholder: '搜索商品名称',
        },
      ];
    },
    categoryType() {
      const categoryType = JSON.parse(sessionStorage.getItem('category_type'));
      return categoryType;
    },
  },
  created() {
    const tsv = this.$route.query.school_category_ids;

    tsv && (this.typeSelectValue = tsv.split('_').map(val => Number(val)));
    const isClick = +sessionStorage.getItem('isClick');
    if (!isClick) {
      sessionStorage.removeItem('session_query');
    }
  },
  methods: {
    // 分类 - 搜索
    onTypeSelect(obj) {
      sessionStorage.setItem('session_query', JSON.stringify({
        school_category_id: obj.id,
        school_category_ids: obj.ids.join('_'),
      }));
    },
    // 授权课包 - 搜索
    searchCall(arr) {
      this.authClass.loading = true;

      if (arr) {
        this.authClass.page = 1;
        this.authClass.search = arr;
      } else {
        arr = [];
      }

      arr = arr.concat([`page:${this.authClass.page}`, `per_page:${this.authClass.per_page}`, 'order[id]:desc'], this.authClass.search);

      this.$http.get(`${this.authClass.api}&${arr.join('&').replace(/:/g, '=')}`).then((res) => {
        this.authClass.list = res;
      }).finally(() => {
        this.authClass.loading = false;
      });
    },

    // 授权课包 - 课程勾选
    GoodsCheck(val, item) {
      this.authClass.loading = true;

      if (item.school_ids.includes(this.authClass.id)) {
        this.$http.delete('/api/course/commodities/open_school', {
          data: {
            commodities_id: item.id,
            school_id: this.authClass.id,
          },
        }).then(() => {
          this.searchCall();
        }).catch(() => {
          this.authClass.loading = false;
        });
      } else {
        this.$http.post('/api/course/commodities/open_school_batch', {
          commodities_id: item.id,
          school_ids: [this.authClass.id],
        })
          .then(() => {
            this.searchCall();
          })
          .catch(() => {
            this.authClass.loading = false;
          });
      }
    },

    // 批量移动
    moreMove(_id) {
      this.moves.form = [{
        attr: 'cascader',
        name: '目录选择',
        width: '80px',
        options: this.typeSelectDataMe[0].childrens,
        props: {
          rules: {
            message: '请选择目录',
            required: true,
            target: 'blur',
          },
        },
        type: 'cascader',
        value: '',
      }];

      this.moves.data = _id;
      this.moves.show = true;
    },
    onMovesForm(valid, data) {
      this.moves.isSubmit = false;

      if (valid) {
        this.$http.patch(`/api/service/operate/clients/${this.moves.data}/school_category_ids`, {
          category_ids: [data.model_cascader[data.model_cascader.length - 1]],
        }).then(() => {
          this.moves.show = false;
          this.$message.success('移动成功');
          this.reload();
        });
      }
    },

    // 授权课包 - 显示
    getAuthClass(row) {
      this.authClass.title = `${row.review_used.name}校区课包选择`;
      this.authClass.id = row.id;
      // equal[open_school_select]=1&
      this.authClass.api = `/api/course/commodities?order[id]=desc&open_school_id=${row.id}&equal[status]=1`;

      if (!this.stage_tag_list.length) {
        this.$http.get('/api/tags?order[order]=desc&equal[type]=stage').then(res => this.stage_tag_list = res.items);
      }

      if (!this.subject_tag_list.length) {
        this.$http.get('/api/tags?order[order]=desc&equal[type]=subject').then(res => this.subject_tag_list = res.items);
      }

      this.authClass.show = true;
    },

    pageCall(obj) {
      obj.page && (this.authClass.page = obj.page);
      obj.per_page && (this.authClass.per_page = obj.per_page);
      this.searchCall();
    },

    // 授权双师课件
    double(row) {
      this.$router.push({ path: '/campus/auth', query: { id: row.id } });
    },
    // 擎想系统课件
    doubleYun(row) {
      this.$router.push({ path: '/campus/yun', query: { id: row.id } });
    },
    // 设置
    setting(row) {
      this.dialogVisible = true;
      this.user_id = row.user_id;
    },
    // 升级代理商
    submitSetting() {
      if (this.form.factor === 1) {
        this.$http
          .post(`/api/service/operate/agent/store/${this.user_id}`)
          .then(() => {
            this.$message.success('升级代理商成功！');
            this.reload();
          })
          .catch((err) => {
            this.$message.error(err.message);
          });
      } else {
        this.dialogVisible = false;
      }
    },
    // 修改课件权限
    switchCourseMake(row) {
      const clients_course_make_status = {
        clients_course_make_status: row.clients_course_make_status === 1 ? 2 : 1,
      };
      this.$confirm('确定修改课件权限吗', '确认', {
        showCancelButton: true,
        type: 'success',
        confirmButtonText: '确定',
        confirmButtonClass: 'el-button--success',
      })
        .then(() => {
          this.$http
            .patch(`/api/service/operate/clients/${row.id}/clients_course_make_status`, clients_course_make_status)
            .then(() => {
              this.$message.success('状态修改成功');
              this.reload();
            })
            .catch((err) => {
              this.$message.error(err.message);
            });
        });
    },
    // 修改录制权限
    switchCourseRecord(row) {
      const clients_record_status = {
        clients_record_status: row.clients_record_status === 1 ? 2 : 1,
      };
      this.$confirm('确定修改录制权限吗', '确认', {
        showCancelButton: true,
        type: 'success',
        confirmButtonText: '确定',
        confirmButtonClass: 'el-button--success',
      })
        .then(() => {
          this.$http
            .patch(`/api/service/operate/clients/${row.id}/clients_record_status`, clients_record_status)
            .then(() => {
              this.$message.success('状态修改成功');
              this.reload();
            })
            .catch((err) => {
              this.$message.error(err.message);
            });
        });
    },
    // 修改练习权限
    switchCourseExercise(row) {
      const clients_imkid_exercise_status = {
        clients_imkid_exercise_status: row.clients_imkid_exercise_status === 1 ? 2 : 1,
      };
      this.$confirm('确定修改练习权限吗', '确认', {
        showCancelButton: true,
        type: 'success',
        confirmButtonText: '确定',
        confirmButtonClass: 'el-button--success',
      })
        .then(() => {
          this.$http
            .patch(`/api/service/operate/clients/${row.id}/clients_imkid_exercise_status`, clients_imkid_exercise_status)
            .then(() => {
              this.$message.success('状态修改成功');
              this.reload();
            })
            .catch((err) => {
              this.$message.error(err.message);
            });
        });
    },
    // 小程序按钮
    setWechat(row) {
      this.$http
        .get(`/api/clients/${row.id}/watch-app-id`)
        .then((res) => {
          this.wechatForm.id = row.id;
          this.wechatDialogVisible = true;
          this.isRelevance = !!res.data;
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    // 关联小程序
    submitWechat() {
      const data = {
        wechat_app_id: this.wechatForm.mark,
      };
      this.$http
        .patch(`/api/service/operate/clients/${this.wechatForm.id}/map-wechat-app-id`, data)
        .then((res) => {
          this.wechatDialogVisible = true;
          this.$message.success('关联成功！');
          this.reload();
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },

    // 显示视频
    showVideo(name, src) {
      this.videoData.title = name;
      this.videoData.src = src;
      this.videoData.show = true;
    },

    // 播放视频
    videoOpen() {
      this.$refs.ref_video.play();
    },

    // 关闭视频
    videoClose() {
      this.$refs.ref_video.pause();
    },

    // 设置会员等级
    setMembershipLevels(row) {
      this.dialogLevel.id = row.id;
      this.dialogLevel.name = row.review_used.name;
      this.dialogLevel.level = row.vip;
      this.dialogLevel.date = row.vip_start_at ? [row.vip_start_at, row.vip_end_at] : [];
      this.dialogLevel.dates = Object.assign([], this.dialogLevel.date);
      // this.dialogLevel.created_at = (new Date(row.created_at)).getTime() + (2 * 24 * 60 * 60 * 1000);
      this.pickerOptions = {
        disabledDate(time) {
          return time.getTime() < (new Date(row.created_at)).getTime() + (2 * 24 * 60 * 60 * 1000);
        },
      };
      this.dialogLevel.show = true;
    },
    dialogLevelSubmit() {
      const obj = {
        vip: this.dialogLevel.level,
      };

      if (this.dialogLevel.date.length) {
        obj.vip_start_at = `${this.dialogLevel.date[0].split(' ')[0]} 00:00:00`;
        obj.vip_end_at = `${this.dialogLevel.date[1].split(' ')[0]} 23:59:59`;
      } else if (this.dialogLevel.level > 0) {
        this.$message.warning('请选择有效日期');
        return;
      }

      this.dialogLevel.loading = true;

      this.$http.patch(`/api/service/operate/clients/${this.dialogLevel.id}/vip`, obj).then(() => {
        this.dialogLevel.show = false;
        this.$message.success('设置成功');
        this.reload();
      }).finally(() => {
        this.dialogLevel.loading = false;
      });
    },
    // 练习收费配置
    practiceFeeConfiguration(row) {
      this.dialogFee.id = row.id;
      this.dialogFee.name = row.review_used.name;
      this.dialogFee.show = true;
      this.dialogFee.loading = true;

      this.$http.get(`api/student/exercise/price?clients_id=${row.id}`).then((res) => {
        this.dialogFee.coin = res.data.price;
        this.dialogFee.loading = false;
      });
    },
    // 查看会员记录
    openMembershipRecords(row) {
      this.dialogMember.show = true;
      this.dialogMember.title = row.review_used.name;
      this.dialogMember.api = `api/service/operate/clients/${row.id}/vip_logs`;
    },
    dialogFeeSubmit() {
      this.dialogFee.loading = true;

      this.$http.patch(`api/service/operate/clients/${this.dialogFee.id}/options/charge_school`, {
        student_exercise: this.dialogFee.coin,
      }).then(() => {
        this.dialogFee.show = false;
        this.$message.success('设置成功');
        this.reload();
      }).finally(() => {
        this.dialogFee.loading = false;
      });
    },
    dialogFeeInput() {
      // this.dialogFee.coin = ~~(this.dialogFee.coin.replace(/[^\d]/g, ''));
      this.dialogFee.coin = parseFloat(this.dialogFee.coin);
    },

    changeLevel() {
      // if ((new Date(this.dialogLevel.date[0])).getTime() < this.dialogLevel.created_at) {
      //   this.dialogLevel.date = Object.assign([], this.dialogLevel.dates);
      //   this.$message.warning('开始日期要大于创建日期+15天');
      // } else {
      //   this.dialogLevel.dates = Object.assign([], this.dialogLevel.date);
      // }
      this.dialogLevel.dates = Object.assign([], this.dialogLevel.date);
    },
    // 校区分类
    // getCategoryType(data){
    // data.forEach(item=>{
    //   this.categoryType[item.id] = item.name
    // })
    // console.log('columns',this.columns);
    // }
    // 年服务
    openAnnualFee(val) {
      this.curRow = val;
      this.feePickerOptions = {
        disabledDate(time) {
          return time.getTime() < (new Date(val.created_at)).getTime() + (2 * 24 * 60 * 60 * 1000);
        },
      };
      this.showAnnualFee = true;
    },
    // 账号数量
    openAccountNum(val) {
      this.curRow = val;
      this.showAccountNum = true;
    },
    // 授权数量
    openAuthNum(val) {
      this.curRow = val;
      this.showAuthorizeNum = true;
    },
    // 变更日志
    openChangeLog(val) {
      this.curRow = val;
      this.showChangeLog = true;
    },
    // 课程上架权限
    changeCourseAuth(row) {
      console.log('row', row);
      const enable_course_package = {
        enable_course_package: row.enable_course_package === 1 ? 0 : 1,
      };
      const text = row.enable_course_package === 1 ? '禁用' : '启用';
      this.$confirm(`该操作将<strong style="color:red">${text}</strong>课件上架权限，是否继续?`, '提示', {
        dangerouslyUseHTMLString: true,
        showCancelButton: true,
        type: 'warning',
        confirmButtonText: '确定',
        confirmButtonClass: 'el-button',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            this.$http
              .patch(`/api/service/operate/clients/${row.id}`, enable_course_package)
              .then(() => {
                done();
                instance.confirmButtonLoading = false;
              })
              .catch((err) => {
                this.$message.error(err.message);
                instance.confirmButtonLoading = false;
              });
          } else {
            done();
          }
        },
      })
        .then(() => {
          this.$message.success('状态修改成功!');
          this.reload();
        });
    },
    // sdk上课权限
    changeSdkAuth(row) {
      let sdk_enable = {
        sdk_enable: 1,
      };
      if (row.configs) {
        sdk_enable = {
          sdk_enable: row.configs.sdk_enable === 1 ? 0 : 1,
        };
      }
      const text = sdk_enable.sdk_enable === 1 ? '启用' : '禁用';
      this.$confirm(`该操作将<strong style="color:red">${text}</strong>sdk上课权限，是否继续?`, '提示', {
        dangerouslyUseHTMLString: true,
        showCancelButton: true,
        type: 'warning',
        confirmButtonText: '确定',
        confirmButtonClass: 'el-button',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            this.$http
              .patch(`/api/clients-configs/clients/${row.id}`, sdk_enable)
              .then(() => {
                done();
                instance.confirmButtonLoading = false;
              })
              .catch((err) => {
                this.$message.error(err.message);
                instance.confirmButtonLoading = false;
              });
          } else {
            done();
          }
        },
      })
        .then(() => {
          this.$message.success('状态修改成功!');
          this.reload();
        });
    },
  },
};
</script>

<style scoped lang="scss">
  .select-check {
    position: absolute;
    bottom: 9px;
    right: 10px;
    height: 23px;
    overflow: hidden;

    /deep/ .el-checkbox__inner {
      width: 23px;
      height: 23px;
      cursor: default;

      &:after {
        height: 10px;
        left: 9px;
        top: 4px;
      }
    }
  }

  .level-date-style {
    width: 200px;
    padding: 0 5px;

    /deep/ .el-icon-date,
    /deep/ .el-input__icon {
      display: none;
    }
    /deep/ .el-range-input {
      width: 48%;
    }
    /deep/ .el-range-separator {
      width: auto;
      line-height: 40px;
      padding: 0;
    }
  }
  .style-fee {
    padding-left: 50px;

    /deep/ .el-input {
      width: 50px;

      input {
        padding: 0;
        text-align: center;
      }
    }
  }
</style>
<style scoped lang="scss">
@import '@/assets/reset.scss';
@import "./goods.scss";
</style>
<style lang="scss">
  .vip-popover {
    margin: 0 0 0 10px !important;
  }

</style>



// WEBPACK FOOTER //
// src/views/CampusManagement/list/index.vue